import React, { useContext, useEffect } from "react";
import "./Meet_our_team.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import Meet_our_team_card from "./meet_our_team_card/Meet_our_team_card";
import {
  GetAllMeetOurTeam,
  GetAllOurProcess,
} from "../../features/website/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";

function Meet_our_team() {
  const dispatch = useDispatch();

  const { language, setLanguage } = useContext(Context);

  const meetOurTeam = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_meet_our_team,
  );

  console.log(meetOurTeam, "meetOurTeam");

  const loadOurStory = async () => {
    await dispatch(GetAllMeetOurTeam({ language }));
  };

  useEffect(() => {
    loadOurStory();
  }, [dispatch, language]);

  return (
    <>
      <section className="Meet_our_team">
        <div className="container">
          <div className="heading_section_holder">
            <div className="heading_holder">
              <h2>
                {language == 1 ? "Meet Our " : "Rencontrez notre "}
                <span>{language == 1 ? "Team" : "équipe"}</span>
              </h2>
            </div>

            <div className="swiper_navigation_holder">
              <div className="icon_holder custom-prev">
                <img
                  className="navigation_icon"
                  src="/assets/images/icon/left_arrow.png"
                  alt="arrow icon"
                />
              </div>

              <div className="icon_holder custom-next">
                <img
                  className="navigation_icon"
                  src="/assets/images/icon/right_arrow.png"
                  alt="arrow icon"
                />
              </div>
            </div>
          </div>

          <div className="swiper_holder">
            <Swiper
              slidesPerView={4}
              spaceBetween={10}
              navigation={{
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
              }}
              loop
              modules={[Navigation]}
              className="Meet_our_team_mySwiper"
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                576: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
            >
              {meetOurTeam?.data?.map((d, index) => (
                <SwiperSlide>
                  <Meet_our_team_card
                    vdo_Src={IDS?.IMG_URL + d?.AboutUsMeetOurTeam?.video}
                    headingText={d?.name}
                    desc_text={d?.sub_title}
                    description={d?.description}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Meet_our_team;
